import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { Row, Col } from 'react-flexbox-grid'
import MyRoutesHeader from './MyRoutesHeader'
import * as routeActions from 'services/routes/actions'
import * as userSelectors from 'services/user/selectors'
import paginator from 'services/paginator/paginator'
import PaginatorControls from 'components/util/PaginatorControls'
import styles from './_myRoutesPage.css'
import charFieldStyles from 'components/forms/CharField/_charField.css'
import selectStyles from 'components/forms/SelectField/_selectField.css'
import Button from 'components/util/Button'
import Svg from 'components/util/Svg'
import MyRouteResults from './MyRouteResults'
import ConfirmModal from 'components/util/ConfirmModal'

const paginatorOptions = {
  name: 'myRoutesPage',
  perPage: 10,
  maxPageButtons: 3,
}

const mapStateToProps = (state) => ({
  userId: userSelectors.selectUserId(state),
})

const mapDispatchToActions = { ...routeActions }

export class MyRoutesPage extends Component {
  static propTypes = {
    userId: PropTypes.number,
    toggleDeleteRouteModal: PropTypes.func,
    deleteRoute: PropTypes.func,
    loadMyRoutesPage: PropTypes.func,
    paginator: PropTypes.object,
  }

  state = {
    routeIdToDelete: null,
    searchInput: '',
    selectValue: '-date_created',
    confirmDeleteRoute: false,
    deleteRouteLoading: false,
  }

  loadPaginatorPage = ({ limit, offset }) => {
    return this.props.loadMyRoutesPage({
      limit,
      offset,
      userId: this.props.userId,
      searchTerm: this.state.searchInput,
      orderBy: this.state.selectValue,
    })
  }

  handleInitializeDeleteRoute = (id) => {
    this.setState({
      routeIdToDelete: id,
      confirmDeleteRoute: true,
    })
  }

  onDeleteRoute = () => {
    const { routeIdToDelete } = this.state

    this.setState({
      deleteRouteLoading: true,
    })

    this.props.deleteRoute(routeIdToDelete).then(() => {
      this.setState({
        confirmDeleteRoute: false,
        deleteRouteLoading: false,
      })

      this.props.paginator.loadPage()
    })

  }

  onCancelDeleteRoute = () => {
    this.setState({
      confirmDeleteRoute: false,
    })
  }

  handleSearchKeypress = (e) => {
    if (e.key === 'Enter') {
      this.props.paginator.loadPage()
    }
  }

  handleSearchInputChange = (e) => {
    this.setState({
      searchInput: e.target.value,
    })
  }

  handleResetSearch = () => {
    this.setState({
      searchInput: '',
    }, () => this.props.paginator.loadPage())
  }

  handleSearchDropdownChange = (e) => {
    this.setState({
      selectValue: e.target.value,
    }, () => this.props.paginator.loadPage())
  }

  handleSortByDate = () => {
    const newOrderBy = this.state.selectValue === 'date_created' ? '-date_created' : 'date_created'

    this.setState({
      selectValue: newOrderBy,
    }, () => this.props.paginator.loadPage())
  }

  handleSortByDistance = () => {
    const newOrderBy = this.state.selectValue === 'distance' ? '-distance' : 'distance'

    this.setState({
      selectValue: newOrderBy,
    }, () => this.props.paginator.loadPage())
  }

  render () {
    const {
      paginator: {
        loading,
        results,
        loadPage,
      },
    } = this.props

    const {
      selectValue,
      searchInput,
      confirmDeleteRoute,
      deleteRouteLoading,
    } = this.state

    return (
      <div className={styles.myRoutesContainer}>
        <MyRoutesHeader />
        <div className={styles.myRoutesTitleContainer}>
          <h3 className={styles.myRoutesTitle}>
            <FormattedMessage
              id='myroutes.title'
              defaultMessage='My Routes' />
          </h3>
          <a className={styles.createRoute} href='/routes/create'>
            <Button
              el='button'
              type='action'
              size='small'>
              <FormattedMessage
                id='myroutes.createaroute'
                defaultMessage='Create a route' />
            </Button>
          </a>
        </div>
        <div className={styles.searchContainer}>
          <Row>
            <Col xs={12} sm={3}>
              <input
                className={charFieldStyles.input}
                placeholder='Enter a keyword'
                onChange={this.handleSearchInputChange}
                value={searchInput}
                onKeyPress={this.handleSearchKeypress} />
            </Col>
            <Col className={styles.searchButton} xs={12} sm={3}>
              <Button
                size='medium'
                type='primary'
                el='button'
                onClick={() => loadPage()}>
                <FormattedMessage
                  id='routesearch.searchbutton'
                  defaultMessage='Search'
                />
              </Button>
              <a className={styles.resetLink} onClick={this.handleResetSearch}>
                <FormattedMessage
                  id='routesearch.reset'
                  defaultMessage='Reset'
                />
              </a>
            </Col>
            <Col xs={12} smOffset={3} sm={3}>
              <div className={selectStyles.inputContainer}>
                <select value={selectValue} className={selectStyles.input} onChange={this.handleSearchDropdownChange}>
                  <option value='-date_created'>Most Recent</option>
                  <option value='date_created'>Oldest</option>
                  <option value='-distance'>Longest</option>
                  <option value='distance'>Shortest</option>
                </select>
                <Svg name='select_down' className={selectStyles.arrow} />
              </div>
            </Col>
          </Row>
        </div>
        <MyRouteResults
          routes={results}
          loading={loading}
          deleteRouteAction={(routeId) => this.handleInitializeDeleteRoute(routeId)}
          sortByDateAction={() => this.handleSortByDate()}
          sortByDistanceAction={() => this.handleSortByDistance()}
          orderBy={selectValue}
          notFoundComponent={
            <FormattedMessage
              id='routesearch.myroutes.notfound'
              defaultMessage='No Routes Found' />
          } />

        <PaginatorControls {...this.props.paginator} />

        <ConfirmModal
          isOpen={confirmDeleteRoute}
          isLoading={deleteRouteLoading}
          confirmAction={this.onDeleteRoute}
          cancelAction={this.onCancelDeleteRoute}
          titleComponent={<FormattedMessage id='myroutes.confirmdelete' defaultMessage='Delete Route?' />}
        />
      </div>
    )
  }
}

export const Page = paginator(paginatorOptions)(MyRoutesPage)
export default connect(mapStateToProps, mapDispatchToActions)(Page)



// WEBPACK FOOTER //
// ./src/components/routes/myRoutes/MyRoutesPage.jsx